var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 11C9.5 11.8284 8.82843 12.5 8 12.5C7.17157 12.5 6.5 11.8284 6.5 11C6.5 10.1716 7.17157 9.5 8 9.5C8.82843 9.5 9.5 10.1716 9.5 11Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 4C3.89543 4 3 4.89543 3 6V16H21V6C21 4.89543 20.1046 4 19 4H5ZM11 11C11 12.6569 9.65685 14 8 14C6.34315 14 5 12.6569 5 11C5 9.34315 6.34315 8 8 8C9.65685 8 11 9.34315 11 11ZM13.25 10C13.6642 10 14 10.3358 14 10.75V13.25C14 13.6642 13.6642 14 13.25 14C12.8358 14 12.5 13.6642 12.5 13.25V10.75C12.5 10.3358 12.8358 10 13.25 10ZM16.5 9.25V13.25C16.5 13.6642 16.1642 14 15.75 14C15.3358 14 15 13.6642 15 13.25V9.25C15 8.83579 15.3358 8.5 15.75 8.5C16.1642 8.5 16.5 8.83579 16.5 9.25ZM18.25 6.5C18.6642 6.5 19 6.83579 19 7.25V13.25C19 13.6642 18.6642 14 18.25 14C17.8358 14 17.5 13.6642 17.5 13.25V7.25C17.5 6.83579 17.8358 6.5 18.25 6.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 17H2V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V17Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportLaptop);
export default __webpack_public_path__ + "static/media/report-laptop.3e9107fe2c07f6a8fb81b05186140d2c.svg";
export { ForwardRef as ReactComponent };